import { render, staticRenderFns } from "./registration-layout.vue?vue&type=template&id=7338f420&"
import script from "./registration-layout.vue?vue&type=script&lang=ts&"
export * from "./registration-layout.vue?vue&type=script&lang=ts&"
import style0 from "./registration-layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports